import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import MessagePage, { Addresses } from './MessagePage';
import userApi from '../../Api/userApi';
import { FACEBOOK_LINK, SPECIAL_QUOTA_LINK, YOUTUBE_LINK } from '../../common/urlLinks';
import { CARD, PILL_SECONDARY, TEXT_LINK } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

const useStyles = makeStyles(() => ({
    side: {
        ...CARD,
        padding: 'clamp(22px, 2.8vw, 30px)',
        borderColor: REDESIGN_COLORS.primaryBorderSoft,
        background: REDESIGN_COLORS.mist,
    },
    title: {
        margin: '0 0 14px',
        fontSize: '1.2rem',
        letterSpacing: '-0.02em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    },
    socials: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        margin: '0 0 18px',
    },
    social: {
        ...PILL_SECONDARY,
        minHeight: '42px',
        padding: '0 16px',
        fontSize: '0.9rem',
    },
    schools: {
        ...TEXT_LINK,
        fontSize: '0.95rem',
    },
    rule: {
        height: '1px',
        margin: '22px 0',
        background: REDESIGN_COLORS.line,
    },
}));

/**
 * The contact page: the shared message form, with a star rating, beside a
 * card with the other ways to reach the team. Sends the contact email.
 */
const ContactUsPage = () => {
    const classes = useStyles();
    const intl = useIntl();

    const side = (
        <aside className={classes.side}>
            <h2 className={classes.title}>
                <FormattedMessage id="redesign.contact.side.title" />
            </h2>
            <div className={classes.socials}>
                <a href={FACEBOOK_LINK} target="_blank" rel="noopener noreferrer" className={classes.social}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H8v3h2v6h3v-6h2.5l.5-3H13v-2c0-.6.4-1 1-1z" />
                    </svg>
                    {intl.formatMessage({ id: 'redesign.footer.social.facebook' })}
                </a>
                <a href={YOUTUBE_LINK} target="_blank" rel="noopener noreferrer" className={classes.social}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M21.6 7.2a2.5 2.5 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.5 2.5 0 0 0 2.4 7.2C2 8.8 2 12 2 12s0 3.2.4 4.8a2.5 2.5 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8C22 15.2 22 12 22 12s0-3.2-.4-4.8zM10 15.5v-7l6 3.5-6 3.5z" />
                    </svg>
                    {intl.formatMessage({ id: 'redesign.footer.social.youtube' })}
                </a>
            </div>
            <Link to={SPECIAL_QUOTA_LINK} className={classes.schools}>
                <FormattedMessage id="redesign.contact.side.schools" />
                <span aria-hidden="true">→</span>
            </Link>
            <div aria-hidden="true" className={classes.rule} />
            <Addresses />
        </aside>
    );

    return (
        <MessagePage
            keyPrefix="redesign.contact"
            eyebrowId="contactus"
            rating
            send={(payload) => userApi.sendEmail(payload)}
            side={side}
        />
    );
};

export default ContactUsPage;
